import React from 'react';
import { Component } from 'react';
import * as THREE from "three";
import { Scene, PerspectiveCamera, WebGLRenderer, AnimationMixer, AnimationClip, Object3D } from "three";
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import DataSevice from '../../../services/dataSevice';
import { WrapperDataModel } from '../../../models/wrapperDataModel';
import Growl from '../../../common/components/growl/growl'
import * as HelperFunctions from '../../../common/helperFunctions';
import * as Constants from '../../../common/constants';
import { connect } from 'react-redux';
import { TagModel } from '../../../models/tagModel';
import TWEEN from '@tweenjs/tween.js';

interface IProps {
    history?: any,
    lang: string
}

interface IState {
    isLoading: boolean;
    loadingPercent: number;
    allData: Array<WrapperDataModel>;
    isZoomIn: boolean;
    isDataUpdated: boolean;
    oldDataTags: Array<TagModel>;
    isPopupVisivle: boolean;
    popupContent: any;
    popupTitle: any;
}

class AssemblyLineSceneComponent extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            isLoading: true,
            loadingPercent: 0,
            allData: new Array<WrapperDataModel>(0),
            isZoomIn: false,
            isDataUpdated: false,
            oldDataTags: new Array<TagModel>(0),
            popupContent: null,
            popupTitle: null,
            isPopupVisivle: false
        }
    }

    container: any;
    scene: Scene = new Scene();
    camera: PerspectiveCamera = new PerspectiveCamera(40, window.innerWidth / window.innerHeight, 1, 5000);
    renderer: WebGLRenderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    labelRenderer: CSS2DRenderer = new CSS2DRenderer();
    weatherStation = React.createRef<HTMLDivElement>();
    common = React.createRef<HTMLDivElement>();
    controls: any;
    loadingManager: any;
    animationFrame: any;
    dataService = new DataSevice();
    interval: any;
    growl: any;
    boxSize: number = 0;
    mixer: AnimationMixer = new AnimationMixer(new Object3D());
    clock = new THREE.Clock();
    animations: Array<AnimationClip> = new Array<AnimationClip>(0);

    mouse: THREE.Vector2 = new THREE.Vector2();
    raycaster: THREE.Raycaster = new THREE.Raycaster();


    componentDidMount() {
        this.initLoading();
        this.initScene();
        this.initObjects();
        this.animate();
        window.addEventListener("resize", this.onWindowResize, false);
        window.addEventListener('wheel', this.onCameraZoom, true);
        window.addEventListener('touchmove', this.onCameraZoom, true);

        window.addEventListener('mousemove', this.onDocumentMouseMove, false);
        window.addEventListener('click', this.onDocumentMouseClick, false);
    }

    componentWillUnmount() {
        cancelAnimationFrame(this.animationFrame);
        clearInterval(this.interval);
        //this.resourceTracker.dispose();
        this.onDestroy();

        window.removeEventListener('wheel', this.onCameraZoom, true);
        window.removeEventListener('touchmove', this.onCameraZoom, true);
        window.removeEventListener("resize", this.onWindowResize, false);

        window.removeEventListener('mousemove', this.onDocumentMouseMove, false);
        window.removeEventListener('click', this.onDocumentMouseClick, false);
    }

    initLoading = () => {
        this.loadingManager = new THREE.LoadingManager(
            () => {
                const loadingScreen = document.getElementById('loading-screen');
                if (loadingScreen) loadingScreen.classList.add('fade-out');
                if (loadingScreen) loadingScreen.addEventListener('transitionend', this.onTransitionEnd);
            },
            (url, itemsLoaded, itemsTotal) => {
                this.setState({ loadingPercent: Math.round(itemsLoaded / itemsTotal * 100) });
            },
            (url) => {
                console.log('There was an error loading ' + url);
            }
        );
    }

    onTransitionEnd = (event: any) => {
        this.setState({ isLoading: false });
        event.target.removeEventListener('transitionend', event.target);
    }

    initScene = () => {
        // Scene        
        //this.scene.background = new THREE.Color(0xe8f9fc);

        // var axesHelper = new THREE.AxesHelper(20000);
        // this.scene.add(axesHelper);

        // Camera
        this.camera.position.x = 1000; // -2000
        this.camera.position.y = 1300; // 20000
        this.camera.position.z = -1000; // 4000

        // Renderer    
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.autoClear = false;
        this.renderer.setClearColor(0x000000, 0.0);
        // this.renderer.shadowMap.enabled = true;
        // this.renderer.shadowMap.type = THREE.PCFShadowMap;
        this.container.appendChild(this.renderer.domElement);

        this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
        this.labelRenderer.domElement.style.position = 'absolute';
        this.labelRenderer.domElement.style.top = "0";
        this.container.appendChild(this.labelRenderer.domElement)

        // RayCaster
        this.raycaster = new THREE.Raycaster();
        this.raycaster.params = {
            Mesh: {},
            Line: { threshold: 0 },
            LOD: {},
            Points: { threshold: 1 },
            Sprite: {}
        };

        // Controls
        this.controls = new OrbitControls(this.camera, this.container);

        // Lights
        const light1 = new THREE.DirectionalLight(0xffffff, 1);
        light1.position.set(-100, 500, -100); // (-10000, 10000, 10000);
        // light1.castShadow = true;
        // light1.shadow.bias = 0.001;
        // light1.shadow.mapSize.width = 16000;
        // light1.shadow.mapSize.height = 16000;
        // light1.shadow.radius = 1;
        this.scene.add(light1);
        // var light1Helper = new THREE.DirectionalLightHelper(light1, 50);
        // this.scene.add(light1Helper);

        const cam = light1.shadow.camera;
        cam.near = 30;
        cam.far = 15000;
        cam.left = -5000;
        cam.right = 5000;
        cam.top = 5000;
        cam.bottom = -5000;
        // const cameraHelper = new THREE.CameraHelper(cam);
        // this.scene.add(cameraHelper);

        var light2 = new THREE.AmbientLight(0xffffff, 1.5);
        light2.position.set(1000, 1000, 1000);
        this.scene.add(light2);
    }

    initObjects = () => {

        const gltfLoader = new GLTFLoader(this.loadingManager);
        gltfLoader.load(Constants.modelAnimation, (gltf: any) => {
            const root = gltf.scene;
            this.scene.add(root);

            this.mixer = new THREE.AnimationMixer(root);
            let oldAnimationsArray: Array<AnimationClip> = gltf.animations;
            let newAnimationsArray: Array<AnimationClip> = new Array<AnimationClip>(0);

            oldAnimationsArray.forEach(r => {
                let animationTracks = r.tracks;
                let allAnimations: AnimationClip = new AnimationClip("All_Animations", r.duration, animationTracks);
                newAnimationsArray.push(allAnimations);
            });

            this.animations = newAnimationsArray;

            let allAnimatios = THREE.AnimationClip.findByName(newAnimationsArray, "All_Animations");
            let animation = this.mixer.clipAction(allAnimatios);
            animation.play();

            // var boxHelper = new THREE.BoxHelper(root);
            // this.scene.add(boxHelper);

            //console.log(HelperFunctions.dumpObject(root).join('\n'));

            // root.traverse((obj: any) => {
            //     if (obj.castShadow !== undefined) {
            //         obj.castShadow = true;
            //         obj.receiveShadow = true;
            //     }
            // });

            const box = new THREE.Box3().setFromObject(root);

            this.boxSize = box.getSize(new THREE.Vector3()).length();
            const boxCenter = box.getCenter(new THREE.Vector3());

            this.camera.near = this.boxSize / 100;
            this.camera.far = this.boxSize * 100;
            this.camera.lookAt(boxCenter.x, boxCenter.y, boxCenter.z);

            // update the Trackball controls to handle the new size
            this.controls.maxPolarAngle = Math.PI / 2.3;
            // this.controls.minPolarAngle = 0;
            this.controls.maxDistance = this.boxSize * 1.5;
            this.controls.minDistance = this.boxSize * 0.3;
            this.controls.target.copy(boxCenter);
            this.controls.enableDamping = true;
            this.controls.dampingFactor = 0.05;
            // this.controls.rotateSpeed = 0.3;
            // this.controls.zoomSpeed = 0.7;
            this.controls.update();
        });
    }

    animate = () => {
        if (this.mixer) {
            this.mixer.update(this.clock.getDelta());
        }
        this.animationFrame = requestAnimationFrame(this.animate);
        this.controls.update();
        TWEEN.update();

        this.renderer.render(this.scene, this.camera);
        this.labelRenderer.render(this.scene, this.camera);
    }

    onDocumentMouseMove = (event: any) => {
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
    }

    onDocumentMouseClick = (event) => {
        event.preventDefault();
    }

    onWindowResize = () => {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
    }

    onCameraZoom = () => {
        let zoomValue = this.camera.position.length();

        if (zoomValue < this.boxSize * .7) {
            if (!this.state.isZoomIn) {
                this.setState({
                    isZoomIn: true
                });
            }
        } else {
            if (this.state.isZoomIn) {
                this.setState({
                    isZoomIn: false
                });
            }
        }
    }

    onNavigationCLick = (path: string) => {
        this.props.history.push(path);
    }

    onDestroy = () => {
        for (let anim of this.animations) {
            this.mixer.uncacheClip(anim);
        }
        HelperFunctions.disposeResource(this.scene);
        // if (this.scene) {
        //   this.scene.dispose();
        //   //@ts-ignore
        //   this.scene = undefined;
        // }

        // this.renderer.forceContextLoss();
        // this.renderer.renderLists.dispose();
        // this.renderer.dispose();
        // //@ts-ignore
        // this.renderer.domElement = undefined;
        // //@ts-ignore
        // this.renderer = undefined;
    }

    removeFromScene = (objectName: string, withLine: boolean) => {
        let objectInScene = this.scene.getObjectByName(objectName);
        if (objectInScene) {
            this.scene.remove(objectInScene);
        }
        if (withLine) {
            this.removeFromScene(objectName + 'Line', false);
            this.removeFromScene(objectName + 'GreenDot', false);
            this.removeFromScene(objectName + 'FirstDot', false);
            this.removeFromScene(objectName + 'SecondDot', false);
        }
    }

    render() {
        return (
            <>
                <Growl ref={(el: any) => this.growl = el} />

                {this.state.isLoading ?
                    <section id="loading-screen">
                        <div id="loader"></div>
                        <div id="loader-percent">{this.state.loadingPercent} %</div>
                    </section> : null}

                <div ref={ref => (this.container = ref)}>
                </div>
            </>
        );
    }

}

const mapsStateToProps = (state: any) => {
    return {
        lang: state.common.lang,
        // animationState: state.common.animationState
    };
}

export default connect(mapsStateToProps, null)(AssemblyLineSceneComponent);
